import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Registro = () => {
     useEffect(() => {
      document.body.style.overflow = 'auto';
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
      return () => {
        document.body.style.overflow = 'hidden';
      };
    }, []);
    
  const navigate = useNavigate();

  const paises = [
    "Argentina", "Costa Rica", "Colombia", "Chile", "El Salvador", "Estados Unidos",
    "Guatemala", "Honduras", "México", "Nicaragua", "Panamá", "Perú", "Paraguay", "República Dominicana", "Uruguay"
  ];

  const handlePaisClick = (pais) => {
    localStorage.setItem("pais", pais);
    if (pais === "Guatemala") {
      navigate("/departamento");
    } else {
      navigate("/crear");
    }
  };

  return (
    <>
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
        <div className="connections-container">
        <div className="back-container">
            <button className="back-btn" onClick={() => navigate("/login")}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
                </svg>
            </button>
        </div>
        <h2 className="connections-title">Elige tu país</h2>
    </div>
      <div className="country-list">
      {paises.map((pais, i) => {
        const flagFileName = pais
          .normalize("NFD")         
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/\s/g, "").slice(0, 3);       

        return (
          <div className="country-item" key={i} onClick={() => handlePaisClick(pais)}>
            <img src={`assets/flags/${flagFileName}.png`} alt={pais} />
            <span>{pais}</span>
            <span className="country-arrow">›</span>
          </div>
        );
      })}
      </div>
    </div>
    </motion.div>
    </>
  );
};

export default Registro;